module.exports = function() {
  return new Worker(__webpack_public_path__ + "8d6969f7b4db6c005dde.worker.js");
};